const urls = 'https://test1.iprox.org.cn/';
const url2 = 'http://20.20.10.129/';
export const menus = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: 'Home',
      ifHomePage: true,
    },
    isShow: true,
    isChildren: false,
    indexval: 1,
    isBlank: false,
    isLogin: false,
    isAdmin: false,
  },
  {
    path: `${urls}page/MSV022.html`,
    name: 'myspace',
    meta: {
      title: 'My Space',
      needLogin: false,
    },
    isShow: true,
    isChildren: false,
    indexval: 2,
    isBlank: true,
    isLogin: false,
    isAdmin: false,
  },
  {
    path: '/browse',
    name: 'browse',
    meta: {
      title: 'Browse',
      needLogin: false,
    },
    isShow: true,
    isChildren: false,
    indexval: 3,
    isBlank: true,
    isLogin: false,
    isAdmin: false,
  },
  // {
  //   path: '/tools',
  //   name: 'tools',
  //   meta: {
  //     title: 'Tools',
  //   },
  // },
  {
    path: '/search',
    name: 'search',
    meta: {
      title: 'Search',
      needLogin: false,
    },
    isShow: true,
    isChildren: false,
    indexval: 4,
    isBlank: true,
    isLogin: false,
    isAdmin: false,
  },
  {
    path: '',
    name: 'submit',
    meta: {
      title: 'Submit',
    },
    isShow: true,
    isChildren: true,
    indexval: 5,
    isBlank: false,
    isLogin: false,
    isAdmin: false,
    children: [
      {
        path: `${urls}page/PCV010.html`,
        name: 'New Project',
        meta: {
          title: 'New Project',
        },
        hidden: false,
        indexval: 1,
        isBlank: true,
      },
      {
        path: `${urls}page/PCV010.html?submitPage=1`,
        name: 'Submit Project',
        meta: {
          title: 'Submit Project',
        },
        hidden: false,
        indexval: 2,
        isBlank: true,
      },
    ],
  },
  // {
  //   path: '',
  //   name: 'Project',
  //   meta: {
  //     title: 'Project',
  //   },
  //   isShow: true,
  //   isChildren: true,
  //   indexval: 6,
  //   isBlank: false,
  //   isLogin: true,
  //   isAdmin: false,
  //   children: [
  //     {
  //       path: urls + 'page/PDV0141.html',
  //       name: 'My Project',
  //       meta: {
  //         title: 'My Project',
  //       },
  //       hidden: false,
  //       indexval: 1,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/PCV010.html',
  //       name: 'New Project',
  //       meta: {
  //         title: 'New Project',
  //       },
  //       hidden: false,
  //       indexval: 2,
  //       isBlank: true,
  //     },
  //   ],
  // },
  // {
  //   path: '',
  //   name: 'Group',
  //   meta: {
  //     title: 'Group',
  //   },
  //   isShow: true,
  //   isChildren: true,
  //   indexval: 7,
  //   isBlank: false,
  //   isLogin: true,
  //   isAdmin: false,
  //   children: [
  //     {
  //       path: urls + 'page/MGV008.html',
  //       name: 'My Group',
  //       meta: {
  //         title: 'My Group',
  //       },
  //       hidden: false,
  //       indexval: 1,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/MGV00802.html',
  //       name: 'Not Joined Group',
  //       meta: {
  //         title: 'Not Joined Group',
  //       },
  //       hidden: false,
  //       indexval: 2,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/GCV007.html',
  //       name: 'Create Group',
  //       meta: {
  //         title: 'Create Group',
  //       },
  //       hidden: false,
  //       indexval: 3,
  //       isBlank: true,
  //     },
  //   ],
  // },
  // {
  //   path: '',
  //   name: 'Super Project',
  //   meta: {
  //     title: 'Super Project',
  //   },
  //   isShow: true,
  //   isChildren: true,
  //   indexval: 8,
  //   isBlank: false,
  //   isLogin: true,
  //   isAdmin: false,
  //   children: [
  //     {
  //       path: urls + 'page/MSP026.html',
  //       name: 'My Super Project',
  //       meta: {
  //         title: 'My Super Project',
  //       },
  //       hidden: false,
  //       indexval: 1,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/MSP0026.html',
  //       name: 'Not Joined Super Project',
  //       meta: {
  //         title: 'Not Joined Super Project',
  //       },
  //       hidden: false,
  //       indexval: 2,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/SPC025.html',
  //       name: 'Create Super Project',
  //       meta: {
  //         title: 'Create Super Project',
  //       },
  //       hidden: false,
  //       indexval: 3,
  //       isBlank: true,
  //     },
  //   ],
  // },
  {
    path: '/admin/statistics/ProjectStatistics',
    name: 'statistics',
    meta: {
      title: 'Statistics',
    },
    isShow: true,
    isChildren: false,
    indexval: 9,
    isBlank: false,
    isLogin: false,
    isAdmin: false,
    notNeedAdmin: true,
    children: [
      {
        path: '/statistics',
        name: 'statistics',
        meta: {
          title: 'Statistics',
        },
        hidden: false,
        indexval: 1,
        isBlank: true,
      },
      {
        path: '/admin/statistics/dbp',
        name: 'Statistics of downloads',
        meta: {
          title: 'Statistics of downloads',
        },
        hidden: false,
        indexval: 2,
        isBlank: true,
      },
    ],
  },
  // {
  //   path: '/analysis',
  //   name: 'Analysis',
  //   meta: {
  //     title: 'Analysis',
  //   },
  //   isShow: true,
  //   isChildren: true,
  //   indexval: 10,
  //   isBlank: false,
  //   isLogin: true,
  //   isAdmin: true,
  //   children: [
  //     {
  //       path: urls + 'page/CAV028.html',
  //       name: 'cvAnalysis',
  //       meta: {
  //         title: 'CV Analysis',
  //       },
  //       hidden: false,
  //       indexval: 1,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/CVP043.html',
  //       name: 'CV Analysis 2',
  //       meta: {
  //         title: 'CV Analysis 2',
  //       },
  //       hidden: false,
  //       indexval: 2,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/DBP044.html',
  //       name: 'importDataToES',
  //       meta: {
  //         title: 'importDataToES',
  //       },
  //       hidden: false,
  //       indexval: 3,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/XFV0293.html',
  //       name: 'Project XML',
  //       meta: {
  //         title: 'Project XML',
  //       },
  //       hidden: false,
  //       indexval: 4,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/XFV0294.html',
  //       name: 'Submitted Project XML',
  //       meta: {
  //         title: 'Submitted Project XML',
  //       },
  //       hidden: false,
  //       indexval: 5,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/XFV029.html',
  //       name: 'XML Files',
  //       meta: {
  //         title: 'XML Files',
  //       },
  //       hidden: false,
  //       indexval: 6,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/XFV0292.html',
  //       name: 'File List',
  //       meta: {
  //         title: 'File List',
  //       },
  //       hidden: false,
  //       indexval: 7,
  //       isBlank: true,
  //     },
  //     {
  //       path: 'admin/statistics/ProjectStatistics',
  //       name: 'Statistics',
  //       meta: {
  //         title: 'Statistics',
  //       },
  //       hidden: false,
  //       indexval: 8,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/DCP040.html',
  //       name: 'Comparasion',
  //       meta: {
  //         title: 'Comparasion',
  //       },
  //       hidden: false,
  //       indexval: 9,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/UMV001.html',
  //       name: 'User Management',
  //       meta: {
  //         title: 'User Management',
  //       },
  //       hidden: false,
  //       indexval: 10,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/APP042.html',
  //       name: 'Possible publications',
  //       meta: {
  //         title: 'Possible publications',
  //       },
  //       hidden: false,
  //       indexval: 11,
  //       isBlank: true,
  //     },
  //     {
  //       path: url2 + 'awstats/awstats.pl?config=www.iprox.org',
  //       name: 'Log Analysis',
  //       meta: {
  //         title: 'Log Analysis ',
  //       },
  //       hidden: false,
  //       indexval: 12,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/SecondFileList.html',
  //       name: 'Export XML by Date',
  //       meta: {
  //         title: 'Export XML by Date',
  //       },
  //       hidden: false,
  //       indexval: 13,
  //       isBlank: true,
  //     },
  //     {
  //       path: urls + 'page/Reanalysis.html',
  //       name: 'Reanalysis',
  //       meta: {
  //         title: 'Reanalysis',
  //       },
  //       hidden: false,
  //       indexval: 14,
  //       isBlank: true,
  //     },
  //   ],
  // },
  {
    path: '',
    name: 'resources',
    meta: {
      title: 'Resources',
    },
    isShow: true,
    isChildren: true,
    indexval: 11,
    isBlank: false,
    isLogin: false,
    isAdmin: false,
    children: [
      {
        path: `${urls}page/spectrum.html`,
        name: 'Universal Spectrum Identifier (USI) Search',
        meta: {
          title: 'Universal Spectrum Identifier (USI) Search',
        },
        hidden: false,
        indexval: 1,
        isBlank: true,
      },
      {
        path: `${urls}page/Reanalysis01.html`,
        name: 'Reanalyzed Datasets',
        meta: {
          title: 'Reanalyzed Datasets',
        },
        hidden: false,
        indexval: 2,
        isBlank: true,
      },
      {
        path: `${urls}proxi/swagger-ui.html`,
        name: 'Web Service APls',
        meta: {
          title: 'Web Service APls',
        },
        hidden: false,
        indexval: 3,
        isBlank: true,
      },
    ],
  },
  {
    path: '',
    name: 'help',
    meta: {
      title: 'Help',
    },
    isShow: true,
    isChildren: true,
    indexval: 12,
    isBlank: false,
    isLogin: false,
    isAdmin: false,
    children: [
      {
        path: `${urls}page/helpEn.html`,
        name: 'User Manual',
        meta: {
          title: 'User Manual',
        },
        hidden: false,
        indexval: 1,
        isBlank: true,
      },
      {
        path: `${urls}page/exampleDataset.html`,
        name: 'An Example Dataset',
        meta: {
          title: 'An Example Dataset',
        },
        hidden: false,
        indexval: 2,
        isBlank: true,
      },
      {
        path: `${urls}page/helpApi.html`,
        name: 'API',
        meta: {
          title: 'API',
        },
        hidden: false,
        indexval: 3,
        isBlank: true,
      },
      {
        path: `${urls}page/helpInformation.html`,
        name: 'Contact Information',
        meta: {
          title: 'Contact Information',
        },
        hidden: false,
        indexval: 4,
        isBlank: true,
      },
      {
        path: '',
        name: 'Data License',
        meta: {
          title: 'Data License',
        },
        hidden: false,
        indexval: 5,
        isBlank: false,
      },
      {
        path: '/admin/changelog',
        name: 'Change Log',
        meta: {
          title: 'Change Log',
        },
        hidden: false,
        indexval: 6,
        isBlank: false,
      },
      {
        path: '/admin/todolist',
        name: 'TodoList',
        meta: {
          title: 'TodoList',
        },
        hidden: false,
        indexval: 6,
        isBlank: false,
      },
    ],
  },
  // {
  //   path: '',
  //   name: 'datalicense',
  //   meta: {
  //     title: 'Data License',
  //   },
  //   isShow: true,
  // },
];
